module.exports = __webpack_public_path__ + "sx13-959404e1.png";